define.alias("shared/components/shared/typeform-survey-trigger", "preview-grid/components/shared/typeform-survey-trigger");